// React Basic and Bootstrap
import React from "react"
import { graphql, Link, useStaticQuery } from "gatsby"
import { Container, Row, Col } from "reactstrap"

// import icons
// import { UilArrowCircleRight } from "@iconscout/react-unicons"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

const AboutAcademy = () => {
  const data = useStaticQuery(graphql`
    {
      markdownRemark(frontmatter: { contentKey: { eq: "academyPage" } }) {
        frontmatter {
          our_story {
            header
            description
            cta_button
            feature {
              features
            }
            featured_image {
              childImageSharp {
                gatsbyImageData
              }
            }
          }
        }
      }
    }
  `)

  const { header, description, cta_button, featured_image } =
    data.markdownRemark.frontmatter.our_story

  // const features = data.markdownRemark.frontmatter.our_story.feature

  return (
    <>
      <section className="section pt-0">
        <Container>
          <Row className="align-items-center">
            <Col lg="5" md="6" xs="12">
              <GatsbyImage
                image={getImage(featured_image)}
                className="img-fluid shadow rounded"
                alt="graduated students of International copywriting academy"
              />
            </Col>
            <Col lg="7" md="6" xs="12" className="mt-4 mt-sm-0 pt-2 pt-sm-0">
              <div className="section-title ms-lg-4">
                <h4 className="title mb-2 mt-3 text-primary">{header}</h4>
                <p
                  className="text-muted"
                  style={{ lineHeight: "2", fontSize: "17px" }}
                >
                  {description}
                </p>
                {/* <ul className="list-unstyled feature-list mb-0 text-muted">
                  {features.map((feature, key) => (
                    <li>
                      <i className=" text-primary h5 mb-0 align-middle me-2">
                        <UilArrowCircleRight />
                      </i>
                      {feature.features}
                    </li>
                  ))}
                </ul> */}
                <Link
                  to="/academy/landing"
                  className="btn btn-outline-primary mt-3"
                >
                  {cta_button}
                </Link>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  )
}

export default AboutAcademy
